import { format, parse } from 'date-fns';
import { DEDUPE_THRESHOLD_IN_MS } from './constants';

export const stripeDataObjectConverter = (
  { name, line1, line2, postalCode, city, country, state },
  cardElement
) => ({
  payment_method: {
    card: cardElement,
    billing_details: {
      address: {
        city,
        country,
        line1,
        line2,
        postal_code: postalCode,
        state
      },
      name,
      phone: null
    }
  }
});

export const dedupeRequest = (lockTimestamp) =>
  lockTimestamp && Date.now() - lockTimestamp < DEDUPE_THRESHOLD_IN_MS;

export const formatDate = (date, dateFormat = 'MMMM d, yyyy') => {
  let dateStr = date;
  // date can include time in some cases
  // for the formatting to still work, use only the date without time
  if (dateStr.length > 10) {
    dateStr = dateStr.substring(0, 10);
  }
  return format(parse(dateStr, 'yyyy-MM-dd', new Date()), dateFormat);
};
